import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import UsersPanel from './UsersPanel';

import { isSuperUser } from '../../lib/utils';

export default class AdminDashboard extends Component {
  render() {
    return (
      <Switch>
        {!isSuperUser() && <Redirect to="404" />}
        <Route path="/" render={props => <UsersPanel {...props} />} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Admin/AdminDashboard.jsx